import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink, setParams } from "../../../../redux/actions";
import { connect } from "react-redux";
import {
  Row,
  Alert,
  Card,
  CardTitle,
  CardBody,
} from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
import ChartCard from "../../../../components/utils/ChartCard";
import AppLocale from "../../../../config/lang";
import { objToQueryString } from "../../../../helpers/Utils";
import { DoughnutChart } from "../../../../components/charts";
import { ThemeColors } from '../../../../helpers/ThemeColors';
import FormCustom from "../../../../components/utils/FormCustom";
import dateRange from "../../../../components/utils/DateRange"

const colors = ThemeColors();
const defaultValue = [
  {Key: "", Value: 0}
]

class AdmUsage extends Component {
  constructor(props) {
    super(props);
    this.M = "AdmUsage."
    this.state = {
      formFields: [],
      filters: null,
      progressBar: false,
      dailyBalance: defaultValue,
      dailyCosts: defaultValue,
      topFlowsData: {
        labels: ['...', '...', '...'],
        datasets: [
          {
            label: '',
            borderColor: [colors.themeColor3, colors.themeColor2, colors.themeColor1],
            backgroundColor: [
              colors.themeColor3_10,
              colors.themeColor2_10,
              colors.themeColor1_10,
            ],
            borderWidth: 2,
            data: [],
          },
        ],
      }
    }
  }

  UNSAFE_componentWillMount() {
    this.createForm()
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.filters?.from && !prevState.filters?.to && this.state.filters?.from && this.state.filters?.to) {
      this.getData();
    }
  }

  componentWillUnmount() {
    this.props.setParams(null)
  }

  createForm () {
    let fields = dateRange(
      {
        type: "daterange",
        range: {
          value: 0
        }
      },
    )

    fields = [...fields,
      {
        col: 3,
        name: "btnFilter",
        type: "button",
        label: 'Apply filter',
        onClick: () => this.getData()
      }
    ]

    this.setState({ formFields: fields })
  }

  getData() {
    const {from, to} = this.state.filters
    if (!from && !to) return
    const params = {
      from,
      to
    }
    const query = objToQueryString(params)
    this.setState({
      dailyBalance: defaultValue,
      dailyCosts: defaultValue
    })
    _axios
      .get(`company/usage?${query}`)
      .then(r => {
        if (r.status >= 0) {
          let { 
            dailyBalance, dailyCosts, pieFlows,
          } = r.data


          const pieFlowsConfig = () => {
            const obj = {
              labels: [],
              datasets: [
                {
                  label: '',
                  borderColor: [colors.themeColor3, colors.themeColor2, colors.themeColor1],
                  backgroundColor: [
                    colors.themeColor3_10,
                    colors.themeColor2_10,
                    colors.themeColor1_10,
                  ],
                  borderWidth: 2,
                  data: [],
                },
              ]
            }

            if (pieFlows) {
              pieFlows.forEach(item => {
                obj.labels.push(item.Key)
                obj.datasets[0].data.push(item.Value)
              })
            }
            return obj
          }

          this.setState({
            ...(dailyBalance.length > 0 && {
              dailyBalance: dailyBalance
            }),
            ...(dailyCosts.length > 0 && {
              dailyCosts: dailyCosts
            }),
            topFlowsData: pieFlowsConfig(),
          });
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBar: false })
      })
  }

  listenStatesForm = (s) => {
    this.setState({filters: s})
  }

  render() {
    const { 
      dailyBalance, dailyCosts, topFlowsData
    } = this.state
    const { locale, params } = this.props
    const L = AppLocale[locale].messages
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                <h1>Usage</h1>
              </Colxx>
            </Row>
          </Colxx>
        </Row>

        {params?.setupMsg && <Alert className="rounded" color="warning">{params.setupMsg}</Alert>}

        <Row>
          <Colxx lg="12" xl="12" className="mb-4">
            <FormCustom
              id={"form-filters-stats"}
              fields={this.state.formFields}
              listenStates={this.listenStatesForm}
              didUpdateStates={true}
            />
          </Colxx>
        </Row>

        <Row>
          <Colxx lg="12" xl="6" className="mb-4">
            <ChartCard
              className="mb-4"
              data={dailyCosts}
              L= {L}
              title="Session cost"
              yAxesMax={Math.ceil(Math.max(...dailyCosts.map(item => item.Value)) * 1.05)}
            />

            <ChartCard
              data={dailyBalance}
              L= {L}
              title="Available balance"
              yAxesMax={Math.ceil(Math.max(...dailyBalance.map(item => item.Value)) * 1.05)}
            />
          </Colxx>
          <Colxx lg="12" xl="6" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle>
                  Spending by flow
                </CardTitle>
                <div className="dashboard-donut-chart">
                  <DoughnutChart shadow data={topFlowsData} />
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser
  return { locale, menuItems, deepLink, params, userAdmin }
}

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(AdmUsage);